/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AddressBook,
    AddressBookFromJSON,
    AddressBookFromJSONTyped,
    AddressBookToJSON,
    Asset,
    AssetFromJSON,
    AssetFromJSONTyped,
    AssetToJSON,
    DiscordInfo,
    DiscordInfoFromJSON,
    DiscordInfoFromJSONTyped,
    DiscordInfoToJSON,
    PhoneNumber,
    PhoneNumberFromJSON,
    PhoneNumberFromJSONTyped,
    PhoneNumberToJSON,
    StandardUser,
    StandardUserFromJSON,
    StandardUserFromJSONTyped,
    StandardUserToJSON,
    UserType,
    UserTypeFromJSON,
    UserTypeFromJSONTyped,
    UserTypeToJSON,
    XpMultiplier,
    XpMultiplierFromJSON,
    XpMultiplierFromJSONTyped,
    XpMultiplierToJSON,
} from './';

/**
 * 
 * @export
 * @interface SupportAgent
 */
export interface SupportAgent extends StandardUser {
}

export function SupportAgentFromJSON(json: any): SupportAgent {
    return SupportAgentFromJSONTyped(json, false);
}

export function SupportAgentFromJSONTyped(json: any, ignoreDiscriminator: boolean): SupportAgent {
    return json;
}

export function SupportAgentToJSON(value?: SupportAgent | null): any {
    return value;
}


